/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 6/10/2023
 */

import React from 'react'
import {Typography, Button } from '@mui/material';
// import backgroundVideo from "../assets/videos/aboutUsCoverVideo2.mp4";
import AboutPageBody from "../components/aboutUs/aboutPageBody";
import ContactBtnDialog from "../components/contact/contactBtnDialog";
import Styles from "./aboutUs.module.css";

const aboutUs = () => {

  return (
    <>

      <div className={Styles.videoCompOuterBox}>
        <video autoPlay muted loop id="myVideo" className={Styles.videoComp}>
          <source src="https://n-ach-file-directory.sgp1.cdn.digitaloceanspaces.com/N_ACH_WEBSITE/N-ach_official_web/videos/aboutUsCoverVideo2.mp4" type="video/mp4" />
        </video>
        <div className={Styles.videoBackgroundBox}>
          <Typography variant='body1' className={Styles.videoBackgroundText}>We have put together a special combination of strategy,
            marketing, design, and digital expertise for your Need for Achievement, design, and digital expertise for your Need for Achievement
          </Typography>
          <ContactBtnDialog />
          
        </div>
      </div>
      <AboutPageBody />
    </>
  );
}


export default aboutUs;


